module.exports = __webpack_public_path__ + "img/price_header.5ae03d1c.svg";